<template>
  <denied-view />
</template>

<script>
/*Denied view wrapper*/

// components
import deniedView from '../../views/denied/Denied';

export default {
  name: "Denied",
  components: {
    deniedView,
  }
}
</script>

